import { render, staticRenderFns } from "./step6-photo.vue?vue&type=template&id=d924e4a8&scoped=true&"
import script from "./step6-photo.vue?vue&type=script&lang=js&"
export * from "./step6-photo.vue?vue&type=script&lang=js&"
import style0 from "./step6-photo.vue?vue&type=style&index=0&id=d924e4a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d924e4a8",
  null
  
)

export default component.exports